<h1 class="mb-2"><mdb-icon fas icon="tasks"></mdb-icon> Tipos de Cliente</h1>

<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Maestros</span>
      <span> /</span>
      <span>Tipos de Cliente</span>
    </p>
  </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
<div class="card mb-2 wow detalle-cliente">
  <div class="card-body justify-content-between">
    <div class="row filtros-header">
      <div></div>
      <button
        type="button"
        mdbBtn
        color="info"
        data-target="#basicExample"
        (click)="muestraModalAgrega(); showModalAgregar()"
        size="sm"
        mdbWavesEffect
      >
        Agregar
      </button>
    </div>
  </div>
</div>

<!-- Cabecera de botones -->
<div class="card mb-2 wow">
  <!--Card content-->
  <div class="card-body">
    <div class="table-responsive">
      <table class="table table-striped table-hover table-sm align-middle">
        <thead class="grey lighten-2">
          <tr>
          
            <th scope="col">Descripcion</th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let tc of tipoclienteList">
          
            <td>{{ tc.descripcion }}</td>
            <td>
              <button
                class="btn-actions-sm"
                color="info"
                mdbBtn
                type="button"
                size="sm"
                mdbWavesEffect
                data-toggle="modal"
                data-target="#basicExample"
                (click)="showModalModificar(); showForEdit(tc)"
                mdbTooltip="Ver"
                placement="right"
              >
                <mdb-icon fas icon="eye"></mdb-icon>
              </button>
              
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<div
  mdbModal
  #centralLarge="mdb-modal"
  class="modal fade"
  id="basicExample"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myModalLabel"
  aria-hidden="true"
  [config]="{ backdrop: true, ignoreBackdropClick: true }"
>
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title w-100 text-left" id="myModalLabel">
          Agregar
        </h4>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
          (click)="centralLarge.hide()"
        >
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="container">
          <form [formGroup]="formAgregarTipoCliente">
            <div class="row">
              <div class="col">
                <div class="md-form">
                  <input
                    value="Codigo"
                    type="text"
                    id="codigo"
                    class="form-control"
                    formControlName="codigo"
                    placeholder="Codigo"
                    maxLength="3"
                    #codigo
                  />
                  <label for="tccodigo">Código</label>
                  <div
                    *ngIf="
                      frmAgregaCodigo.invalid &&
                      (frmAgregaCodigo.dirty || frmAgregaCodigo.touched)
                    "
                  >
                    <mdb-error *ngIf="frmAgregaCodigo.errors.required">
                      El código es requerido
                    </mdb-error>
                    <mdb-error *ngIf="frmAgregaCodigo.errors.maxlength">
                      El código no puede superar los 3 caracteres
                    </mdb-error>
                    <mdb-error *ngIf="frmAgregaCodigo.errors.minlength">
                      El código debe tener como mínimo 3 caracteres
                    </mdb-error>
                  </div>
                </div>
                <div class="md-form">
                  <input
                    placeholder="Descripcion"
                    class="form-control"
                    type="text"
                    id="descripcion"
                    formControlName="descripcion"
                    maxLength="15"
                    value=""
                    #descripcion
                  />
                  <label for="descripcion">Descripción</label>
                  <div
                    *ngIf="
                      frmAgregaDescripcion.invalid &&
                      (frmAgregaDescripcion.dirty ||
                        frmAgregaDescripcion.touched)
                    "
                  >
                    <mdb-error *ngIf="frmAgregaDescripcion.errors.required">
                      La descripción es requerida
                    </mdb-error>
                    <mdb-error *ngIf="frmAgregaDescripcion.errors.maxlength">
                      La descripción no puede superar los 15 caracteres
                    </mdb-error>
                    <mdb-error *ngIf="frmAgregaDescripcion.errors.minlength">
                      La descripción debe tener como mínimo 5 caracteres
                    </mdb-error>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div class="modal-footer justify-content-between">
        <button
          type="button"
          class="btn btn-default waves-light"
          data-dismiss="modal"
          (click)="centralLarge.hide()"
          mdbWavesEffect
        >
          Cerrar
        </button>
        <button
          type="button"
          class="btn btn-secondary waves-light"
          mdbWavesEffect
          [disabled]="!formAgregarTipoCliente.valid"
          (click)="ValidaQueExisteDatosTipoCliente(); centralLarge.hide()"
        >
          Guardar
        </button>
      </div>
    </div>
  </div>
</div>

<div
  mdbModal
  #centralLargex="mdb-modal"
  class="modal fade"
  id="basicExamplex"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myModalLabel"
  aria-hidden="true"
  [config]="{ backdrop: true, ignoreBackdropClick: true }"
>
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title w-100 text-left" id="myModalLabel">
          Modificar Tipos de Cliente
        </h4>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
          (click)="centralLargex.hide()"
        >
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="container">
          <form [formGroup]="formEditarTipoCliente">
            <div class="row">
              <div class="col">
                <div class="md-form">
                  <input
                    type="text"
                    id="codigox"
                    formControlName="codigo"
                    class="form-control"
                    maxLength="3"
                    #codigox
                  />
                  <label for="codigox">Código</label>
                </div>
                <div class="md-form">
                  <input
                    formControlName="descripcion"
                    class="form-control"
                    type="text"
                    id="descripcionx"
                    maxLength="15"
                    #descripcionx
                  />
                  <label for="descripionx">Descripcion</label>
                  <div
                    *ngIf="
                      frmEditarDescripcion.invalid &&
                      (frmEditarDescripcion.dirty ||
                        frmEditarDescripcion.touched)
                    "
                  >
                    <mdb-error *ngIf="frmEditarDescripcion.errors.required">
                      La descripción es requerida
                    </mdb-error>
                    <mdb-error *ngIf="frmEditarDescripcion.errors.maxlength">
                      La descripción no puede superar los 3 caracteres
                    </mdb-error>
                    <mdb-error *ngIf="frmEditarDescripcion.errors.minlength">
                      La descripción debe tener como mínimo 15 caracteres
                    </mdb-error>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div class="modal-footer justify-content-between">
        <button
          type="button"
          class="btn btn-default waves-light"
          data-dismiss="modal"
          (click)="centralLargex.hide()"
          mdbWavesEffect
        >
          Cerrar
        </button>
        <button
          type="button"
          class="btn btn-secondary waves-light"
          mdbWavesEffect
          [disabled]="!formEditarTipoCliente.valid"
          (click)="actualizar(); centralLargex.hide()"
        >
          Guardar
        </button>
      </div>
    </div>
  </div>
</div>
